(function () {
  if (window.GneisMoneyFormatterLoaded) return;
  window.GneisMoneyFormatterLoaded = true;

  var SELECTOR = '[data-gneis-money]';

  function defaultCurrency() {
    if (
      window.theme &&
      window.theme.currency &&
      window.theme.currency.currencyCode
    ) {
      return window.theme.currency.currencyCode;
    }

    if (
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.active
    ) {
      return window.Shopify.currency.active;
    }

    return 'SEK';
  }

  function defaultLocale() {
    if (
      window.theme &&
      window.theme.currency &&
      window.theme.currency.locale
    ) {
      return window.theme.currency.locale;
    }

    if (window.Shopify && window.Shopify.locale) {
      return window.Shopify.locale;
    }

    return document.documentElement.lang || 'sv-SE';
  }

  function formatMoney(cents, options) {
    options = options || {};

    var numericCents = Number(cents);
    if (!Number.isFinite(numericCents)) return '';

    var currency = options.currency || defaultCurrency();
    var locale = options.locale || defaultLocale();
    var form = options.form === 'code' ? 'code' : 'symbol';
    var amount = numericCents / 100;

    // Hide ,00/.00 for whole prices, but preserve real minor units if they exist.
    var roundedCents = Math.round(Math.abs(numericCents));
    var hasMinorUnits = roundedCents % 100 !== 0;

    var numberFormatOptions = {
      style: 'currency',
      currency: currency,
      currencyDisplay: form,
      minimumFractionDigits: hasMinorUnits ? 2 : 0,
      maximumFractionDigits: hasMinorUnits ? 2 : 0
    };

    try {
      return new Intl.NumberFormat(locale, numberFormatOptions).format(amount);
    } catch (error) {
      try {
        return new Intl.NumberFormat('en', numberFormatOptions).format(amount);
      } catch (fallbackError) {
        return String(amount) + ' ' + currency;
      }
    }
  }

  function formatElement(element) {
    if (!element || !element.matches || !element.matches(SELECTOR)) return;

    var amount = element.getAttribute('data-gneis-money-amount');
    var currency = element.getAttribute('data-gneis-money-currency') || defaultCurrency();
    var locale = element.getAttribute('data-gneis-money-locale') || defaultLocale();
    var form = element.getAttribute('data-gneis-money-form') || 'symbol';

    var formatted = formatMoney(amount, {
      currency: currency,
      locale: locale,
      form: form
    });

    if (formatted) {
      element.textContent = formatted;
    }
  }

  function hydrate(root) {
    root = root || document;

    if (root.nodeType === 1 && root.matches && root.matches(SELECTOR)) {
      formatElement(root);
    }

    if (!root.querySelectorAll) return;

    root.querySelectorAll(SELECTOR).forEach(function (element) {
      formatElement(element);
    });
  }

  window.GneisMoney = {
    format: formatMoney,
    hydrate: hydrate
  };

  function boot() {
    hydrate(document);

    if (!document.documentElement) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            hydrate(node);
          }
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('theme:cart:change', function () {
    hydrate(document);
  });

  document.addEventListener('cart:refresh', function () {
    hydrate(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    hydrate(event.target || document);
  });
})();
